import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "dex-reconcile-scan-rekon-results-table",
  class: "w-full relative"
}
const _hoisted_2 = { class: "text-black-lp-100 font-bold text-sm" }
const _hoisted_3 = { class: "text-10px font-medium text-gray-lp-800 flex rounded-full px-2 bg-gray-lp-200 max-w-max" }
const _hoisted_4 = { class: "text-14px text-black-lp-100" }
const _hoisted_5 = { class: "text-14px text-black-lp-100" }
const _hoisted_6 = { class: "text-14px text-black-lp-100" }
const _hoisted_7 = { class: "text-14px text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TableV2, {
      loading: _ctx.isLoading,
      columns: _ctx.columns,
      data: _ctx.rows,
      isSorting: false,
      isQuickSearch: false,
      isShowPagination: true,
      isSpaceTop: false,
      isNoPaddingBottom: "",
      hidePagination: "",
      customButtonAction: _ctx.customButton,
      onRequest: _ctx.onRequest
    }, {
      "no-stt-shipment": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_2, _toDisplayString(item.stt.sttNo), 1)
      ]),
      product: _withCtx(({ item }) => [
        _createVNode("span", _hoisted_3, _toDisplayString(item.stt.sttProductType), 1)
      ]),
      commodity: _withCtx(({ item }) => [
        _createVNode("span", _hoisted_4, _toDisplayString(item.stt.sttCommodityName), 1)
      ]),
      piece: _withCtx(({ item }) => [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.formatQuantity(item.stt.sttTotalPiece)), 1)
      ]),
      "gross-weight": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formatWeight(item.stt.sttGrossWeight)), 1)
      ]),
      "volume-weight": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.formatWeight(item.stt.sttVolumeWeight)), 1)
      ]),
      _: 1
    }, 8, ["loading", "columns", "data", "customButtonAction", "onRequest"])
  ]))
}